import { DesktopMenu } from 'components/Menu/CustomerPortalMenu/DesktopMenu';
import {
  Header,
  TitleContainer,
  MenuContainer,
  Title,
  CompanyLogo,
  StyledFormGroup,
  CompanySelect,
  CompanyKnowMoreDiv,
} from './styled';
import { ReactComponent as TitleIconWeb } from 'assets/icons/logo-leankeep-w-hexa.svg';
import { ReactComponent as TitleIconMob } from 'assets/icons/logo-leankeep-mobile.svg';
import { MenuMobile } from 'components/Menu/CustomerPortalMenu/MobileMenu';
import { useMediaQuery } from 'react-responsive';
import { useEffect, useState, useContext } from 'react';
import { HeaderFilterService } from 'services/main';
import { useCookies } from 'react-cookie';
import { URLS } from 'constants/urls';
import { ReactComponent as OpenIcon } from 'assets/icons/open-icon-o.svg';

import { FiltersContext } from 'context/GlobalFiltersContext';
export const CustomerPortalHeader = ({ setOpenMyProfile, openMyProfile }) => {
  const isDesktop = useMediaQuery({ minWidth: 1081 });
  const { setFiltersContext } = useContext(FiltersContext);
  const [companies, setCompanies] = useState([]);
  const [, setCookie] = useCookies();
  const fetchCompanies = async () => {
    try {
      const response = HeaderFilterService.companies();
      const { data } = await response;
      const fields = data?.map(item => ({
        label: item?.name,
        value: item?.id,
        logo: item?.logoPath,
        tipoNome: item?.tipoNome,
      }));
      setCompanies(fields);
      setCookie(
        'companies',
        {
          id: String(data?.[0]?.id),
          name: data?.[0]?.name,
          tipoNome: data?.[0]?.tipoNome,
        },
        { path: '/', domain: URLS.cookieDomain },
      );
      setFiltersContext(headerFiltersContext => ({
        ...headerFiltersContext,
        headerFilters: {
          ...headerFiltersContext.headerFilters,
          companies: {
            id: data?.[0]?.id,
            name: data?.[0]?.name,
            logoPath: data?.[0]?.logoPath,
            tipoNome: data?.[0]?.tipoNome,
          },
        },
      }));
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    fetchCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [isOpenMenuMobile, setIsOpenMenuMobile] = useState(false);

  const handleIconClick = () => {
    setOpenMyProfile(false);
    setIsOpenMenuMobile(false);
  };
  return (
    <Header>
      <TitleContainer>
        <Title>
          {isDesktop && <DesktopMenu setOpenMyProfile={setOpenMyProfile} openMyProfile={openMyProfile} />}
          <div onClick={handleIconClick}>{isDesktop === true ? <TitleIconWeb /> : <TitleIconMob />}</div>
        </Title>
        {isDesktop && (
          <CompanyKnowMoreDiv>
            <StyledFormGroup label={'Empresa'}>
              <CompanySelect
                size="small"
                hasOnlyUnitsWithSubgroup={true}
                options={companies}
                defaultValue={companies?.length > 1 ? '' : companies?.[0]?.value}
                value={companies?.length > 1 ? '' : companies?.[0]?.value}
                isSearchDisabled={true}
                isClearInputActive={false}
                disabled={false}
              />
            </StyledFormGroup>
            <a href="https://leankeep.movidesk.com/kb/pt-br/article/533241" target="_blank">
              Saiba como usar o Portal do Cliente
              <OpenIcon />
            </a>
          </CompanyKnowMoreDiv>
        )}
      </TitleContainer>
      <MenuContainer>
        {!isDesktop && (
          <MenuMobile
            companies={companies}
            setOpenMyProfile={setOpenMyProfile}
            openMyProfile={openMyProfile}
            isOpen={isOpenMenuMobile}
            setIsOpen={setIsOpenMenuMobile}
          />
        )}
        {isDesktop && (
          <CompanyLogo>
            <img src={process.env.REACT_APP_URL_IMAGES + `${companies?.[0]?.logo}`} alt="" />{' '}
          </CompanyLogo>
        )}
      </MenuContainer>
    </Header>
  );
};
